export default "__VITE_PUBLIC_ASSET__008987ef__"